import { ShieldCheck, Crown, User } from "lucide-react";

const MAP = {
    admin: { label: "OWNER", color: "#facc15", border: "border-[#facc15]/50", bg: "bg-[#1f1a05]", icon: Crown },
    support: { label: "SUPPORT", color: "#22d3ee", border: "border-[#22d3ee]/55", bg: "bg-[#06181f]", icon: ShieldCheck },
    user: null,
};

export const RoleBadge = ({ role, size = "sm" }) => {
    const r = MAP[role];
    if (!r) return null;
    const Icon = r.icon;
    const padding = size === "lg" ? "px-2.5 py-1 text-xs" : "px-1.5 py-0.5 text-[10px]";
    return (
        <span
            className={`inline-flex items-center gap-1 rounded-md border ${r.border} ${r.bg} font-mono uppercase tracking-wider ${padding}`}
            style={{ color: r.color }}
            title={r.label}
            data-testid={`role-badge-${role}`}
        >
            <Icon className={size === "lg" ? "w-3.5 h-3.5" : "w-3 h-3"} aria-hidden="true" />
            <span>{r.label}</span>
        </span>
    );
};

export const SupportBadge = ({ size = 16 }) => (
    <span
        className="inline-flex items-center justify-center rounded-md"
        style={{ background: "#06181f", border: "1px solid #22d3ee99", boxShadow: "0 0 12px #22d3ee55" }}
        title="SUPPORT"
    >
        <ShieldCheck style={{ color: "#22d3ee", width: size, height: size, padding: 2 }} />
    </span>
);

export const TierBadge = ({ tier }) => {
    if (!tier || tier === "free") return null;
    const map = {
        pro: { label: "PRO", color: "#a855f7" },
        sports_premium: { label: "PREMIUM", color: "#ef4444" },
    };
    const t = map[tier];
    if (!t) return null;
    return (
        <span className="inline-flex items-center gap-1 rounded-md border px-1.5 py-0.5 text-[10px] font-mono uppercase" style={{ color: t.color, borderColor: `${t.color}66`, background: `${t.color}11` }}>
            <User className="w-3 h-3" /> {t.label}
        </span>
    );
};
